import Cookies from 'js-cookie';

//const MAIN_URL = 'http://localhost:3000/';
const MAIN_URL = 'https://apps.festivehq.com/apis/';
export const GET_TAGS = `${MAIN_URL}tags.json`;
export const GET_ORDERS = `${MAIN_URL}orders.json`;
export const GET_REVIEWS = `${MAIN_URL}reviews.json`;
export const GET_BANNERS = `${MAIN_URL}banners.json`;
export const GET_CAROUSEL = `${MAIN_URL}carousel.json`;
export const GET_PRODUCTS = `${MAIN_URL}products.json`;
export const GET_BOOKS = `${MAIN_URL}books.json`;
export const GET_DATA = `${MAIN_URL}issuedata.json`;
export const GET_AUDIENCES = `${MAIN_URL}audiences.json`;
export const GET_PROMOCODES = `${MAIN_URL}promocodes.json`;
export const GET_CATEGORIES = `${MAIN_URL}categories.json`;

export const URLS = {
  GET_TAGS,
  GET_ORDERS,
  GET_BANNERS,
  GET_REVIEWS,
  GET_CAROUSEL,
  GET_PRODUCTS,
  GET_BOOKS,
  GET_DATA,
  GET_AUDIENCES,
  GET_PROMOCODES,
  GET_CATEGORIES,
};

// Shopify Store Configuration
export const SHOPIFY_STORES = {
  USA: {
    url: 'https://festivehq.myshopify.com/api/2025-07/graphql.json',
    token: '223e6f6958a6e1568db68d8891388212',
  },
  INDIA: {
    url: 'https://in.festivehq.com/api/2025-07/graphql.json',
    token: '7061d5be89513b8d01e171d44f83584c',
  },
};

// Helper: Get the correct store config based on loggedInStoreKey
export const getActiveStoreConfig = () => {
  const storeKey = localStorage.getItem('loggedInStoreKey') || Cookies.get('loggedInStoreKey') || 'USA';
  return SHOPIFY_STORES[storeKey as keyof typeof SHOPIFY_STORES] || SHOPIFY_STORES.USA;
};
